import { useDictionary } from "hooks/use-dictionary";
import { FileRecord } from "types/file-record";
import FileViewButton from "./file-view-button";

export type SurveyFormFileListProps = {
  files: FileRecord[];
  readonly publicId?: string;
};

export const SurveyFormFileList = ({ files, publicId }: SurveyFormFileListProps) => {
  const dict = useDictionary();

  if (files && files.length > 0) {
    return (
      <div>
        <div className="font-bold mb-2">
          {dict.programs.programDescriptionFiles}
        </div>
        <div className="space-y-3">
          {files.map((file, index) => (
            <FileViewButton file={file} key={index} publicId={publicId} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="font-medium text-gray-700">
      {dict.programs.noProgramDescriptionFiles}
    </div>
  );
};
